<a mat-icon-button color="primary" [href]="url" target=_blank matTooltip="Tutoriel application Méteo des Services">
  <mat-icon>help</mat-icon>
</a>